module.exports = (__webpack_require__(0))(7);


//////////////////
// WEBPACK FOOTER
// delegated ./src/router.js from dll-reference girder_plugin_jobs
// module id = 5
// module chunks = 0